export const environment = {
  production: true,
  version: "010723319bf265e8b542cc8cfba94ceb65e94127",
  name: "PROD",
  apiUrl: "//taiga-api.discovery.com/api/",
  apiTranslateUrl:
    "https://translation.googleapis.com/language/translate/v2?key=AIzaSyCjnksKQm3U6vgr00R71iRJEG5oU5dt6_s",
  inflowURL: "https://inflow.eurosport.com/",
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts